enum configuredWebchargeActions {
  deleteConfiguredWebcharges = "DeleteConfiguredWebcharges",
  createConfiguredWebcharges = "CreateConfiguredWebcharges",
  updateConfiguredWebcharges = "UpdateConfiguredWebcharges"
}

export {
  configuredWebchargeActions
}
